import { ChevronLeft, ChevronRight } from "lucide-react";

function pageNumbers(page, totalPages) {
  if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
  if (page <= 4) return [1, 2, 3, 4, 5, "…", totalPages];
  if (page >= totalPages - 3) return [1, "…", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
  return [1, "…", page - 1, page, page + 1, "…", totalPages];
}

export function PaginationFooter({ page, pageSize, total, onPageChange, label = "hoardings" }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t px-4 py-3 sm:px-5 sm:py-4" style={{ borderColor: "var(--hx-border)", background: "color-mix(in srgb, var(--hx-surface) 82%, var(--hx-bg))" }}>
      <span className="text-xs text-slate-500">
        Showing{" "}
        <span className="font-semibold text-slate-900">{total ? (page - 1) * pageSize + 1 : 0}</span>
        {" "}to{" "}
        <span className="font-semibold text-slate-900">{Math.min(page * pageSize, total)}</span>
        {" "}of{" "}
        <span className="font-semibold text-slate-900">{total}</span>
        {" "}{label}
      </span>
      {totalPages > 1 && (
        <div className="flex items-center gap-1">
          <button type="button" aria-label="Previous page" disabled={page === 1} onClick={() => onPageChange(page - 1)} className="flex h-8 w-8 items-center justify-center rounded-lg border text-slate-600 transition-all hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-30" style={{ borderColor: "var(--hx-border)" }}>
            <ChevronLeft size={14} />
          </button>
          {pageNumbers(page, totalPages).map((item, index) => item === "…" ? (
            <span key={`ellipsis-${index}`} className="flex h-8 w-6 items-center justify-center text-xs text-slate-400">…</span>
          ) : (
            <button
              type="button"
              key={item}
              aria-label={`Page ${item}`}
              onClick={() => onPageChange(item)}
              className={`flex h-8 w-8 items-center justify-center rounded-lg text-xs font-semibold transition-all ${item === page ? "bg-blue-600 text-white shadow-sm shadow-blue-200" : "border text-slate-600 hover:bg-slate-100 hover:shadow-sm"}`}
              style={item === page ? undefined : { borderColor: "var(--hx-border)" }}
            >
              {item}
            </button>
          ))}
          <button type="button" aria-label="Next page" disabled={page === totalPages} onClick={() => onPageChange(page + 1)} className="flex h-8 w-8 items-center justify-center rounded-lg border text-slate-600 transition-all hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-30" style={{ borderColor: "var(--hx-border)" }}>
            <ChevronRight size={14} />
          </button>
        </div>
      )}
    </div>
  );
}
